import { styled } from 'src/ui/theme'

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`
